let routes = [
  {
    path: '/information',
    component: () => import('@/views/personal/information/information'),
    meta: {
      title: '个人信息',
    },
  },
  {
    path: '/headImg',
    component: () => import('@/views/personal/headImg/headImg'),
    meta: {
      title: '头像',
    },
  },
  {
    path: '/setAdress',
    component: () => import('@/views/personal/setAdress/setAdress'),
    meta: {
      title: '常住地址',
    },
  },
  {
    path: '/feedBack',
    component: () => import('@/views/feedBack/feedBack'),
    meta: {
      title: '意见反馈',
    },
  },
  {
    path: '/feedBackHistory',
    component: () => import('@/views/feedBack/feedBackHistory'),
    meta: {
      title: '历史反馈',
    },
  },
  {
    path: '/aboutUs',
    component: () => import('@/views/personal/aboutUs/aboutUs'),
    meta: {
      title: '关于我们',
    },
  },

  

  {
    path:'/chatDetail',
    component:() => import('@/views/chat/chatDetail'),
    meta:{
      title: '消息',
    }
  },
];
export default routes;



// WEBPACK FOOTER //
// ./src/router/routerPage/Home.js